/**
 * Back chevron on the product page (rendered by snippets/davitta-breadcrumb).
 *
 * When the visitor arrived from another page of this shop, act like the
 * browser's back button so filters, scroll position and pagination on the
 * collection survive. On a direct landing (search, ads, shared link) there is
 * nothing useful to go back to, so the anchor's own href — the collection
 * crumb, or home — takes over untouched.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-davitta-pdp-back]');
  if (!link) return;

  if (window.history.length > 1 && document.referrer && new URL(document.referrer).host === window.location.host) {
    event.preventDefault();
    window.history.back();
  }
});
